import { Routes } from '@angular/router';

export const routes: Routes = [
    { path: '', loadComponent: () => import('./gwqcp/gwqcp/gwqcp.component').then(m => m.GWQCPComponent),
        children: [
        ]
     },
];
